import { useCopyJSON } from '../../../lib/hooks/useCopyJSON';
import { useTextField } from '../../../lib/hooks/useTextField';
import { CodeContentCombinedProps } from './types';

const usePresenter = (props: CodeContentCombinedProps): CodeContentCombinedProps => {
  const { copyJSON } = useCopyJSON();
  const {
    handleBlur,
    handleKeyDown,
    handleTextChanged,
    textAreaRef,
    textValue,
  } = useTextField(props);

  const onCopyButtonClick = async (event?: React.MouseEvent<HTMLElement>) => {
    event?.preventDefault();
    event?.stopPropagation();
    await copyJSON(textValue);
  };

  return {
    ...props,
    button: {
      icon: {
        asset: 'Copy',
      },
      onMouseDown: onCopyButtonClick,
    },
    textArea: {
      onBlur: handleBlur,
      onKeyDown: handleKeyDown,
      onTextChanged: handleTextChanged,
      textValue: textValue,
      resizeToContent: true,
    },
    text: { value: textValue },
    textAreaRef,
  };
};

export default usePresenter;
